import { safeLocalStorage } from 'Utilities/storages';

export const getFinanceFlag = (key?: string): boolean | null => safeLocalStorage.getItem(`${key}_finance`);

export const setFinanceFlag = (key: string, value: boolean): void => safeLocalStorage.setItem(`${key}_finance`, value);

export const removeFinanceFlag = (key?: string): void => safeLocalStorage.removeItem(`${key}_finance`);
